<h2 matDialogTitle>Rechtliche Hinweise</h2>

<mat-dialog-content>
  <div class="mat-body-medium">
    <p>
      Die SaniUp GmbH prüft und aktualisiert die Informationen auf ihren Webseiten regelmäßig. Trotz aller Sorgfalt können sich Daten
      inzwischen verändert haben. Eine Haftung oder Garantie für die Aktualität, Richtigkeit und Vollständigkeit der bereitgestellten
      Informationen wird daher nicht übernommen. Gleiches gilt für alle anderen Webseiten, auf die mittels Hyperlink verwiesen wird. Die
      SaniUp GmbH ist für den Inhalt externer Webseiten, die über solche Verlinkungen erreicht werden, nicht verantwortlich.
    </p>
    <p>
      Die SaniUp GmbH behält sich zudem das Recht vor, Änderungen oder Ergänzungen der bereitgestellten Informationen jederzeit vorzunehmen.
    </p>
    <p>
      Inhalt und Struktur der Webseiten der SaniUp GmbH sind urheberrechtlich geschützt. Die Vervielfältigung von Informationen oder Daten,
      insbesondere die Verwendung von Texten, Textausschnitten oder Bildmaterial, bedarf der vorherigen schriftlichen Zustimmung der SaniUp
      GmbH.
    </p>
  </div>

  <mat-action-list role="list">
    @for (link of legalLinks; track $index) {
      <a role="listitem" mat-list-item [href]="link.url" target="_blank" rel="noopener noreferrer">
        <span matListItemIcon>
          <mat-icon>{{ link.icon }}</mat-icon>
        </span>
        <span matListItemTitle>{{ link.label }}</span>
        <span matListItemMeta>
          <mat-icon>arrow_right</mat-icon>
        </span>
      </a>
    }
  </mat-action-list>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" mat-button matDialogClose cdkFocusInitial>Okay</button>
</mat-dialog-actions>
